import React, { useEffect, useState, useRef } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

const AppMobileFooter = () => {
  const { t } = useTranslation('common')
  const activePageRef = useRef()

  const [activePage, setActivePage] = useState('dashboard')
  const router = useRouter()

  useEffect(() => {
    setActivePage(router.pathname)
  }, [router.pathname])

  useEffect(() => {
    if (activePageRef.current) {
      activePageRef.current.focus()
    }
  }, [activePage])

  return (
    <div className="w-full bg-white z-[9999] mt-4 md:hidden">
      <h2 className="font-bold text-3xl mb-4 pl-4">Dashboard</h2>
      <ul className="flex items-center content-center pl-1 flex-nowrap overflow-x-auto">
        {['dashboard', 'media', 'api-keys', 'favorites', 'billing'].map((item, i) => {
          return (
            <li
              key={`dash-${item}-${i}`}
              onClick={() => {
                router.push({ pathname: `/${item}` })
              }}
              ref={activePage === item ? activePageRef : null}
              className={`flex items-center gap-2 cursor-pointer px-5 flex-[0_0_auto] border-b-2 border-solid
							py-2 ${activePage === `/${item}` ? '!text-[#3b35f3] font-bold border-black' : ' border-[#DBDBE9] '}`}
            >
              <img
                src={
                  activePage === `/${item}`
                    ? `/assets/dashboard/${item}-icon-active.svg`
                    : `/assets/dashboard/${item}-icon.svg`
                }
                alt={item}
                className={`${activePage === `/${item}` && 'filter invert'}`}
              />
              <span className={`text-[#6c727e] text-base ${activePage === `/${item}` ? '!text-black font-bold' : ''}`}>
                {t(`pages.${item}`)}
              </span>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default AppMobileFooter
